import axios from "axios";

import * as Constants from "../constants";
import { getToken } from "./utils";

const DB = (config) => {
  //interceptors handle network error
  const header = {
    Authorization: "?epjtn" + getToken(),
  };
  axios.interceptors.response.use(
    // Successful response
    (response) => {
      return response;
    },
    // Error response
    (error) => {
      if (!error.response) {
        error.response = {
          data: "Network Error",
          status: 500,
        };
      }

      return Promise.reject(error);
    }
  );

  config.baseURL = Constants.BASEURL;
  // if there is no ep token, we don't pass Auth header
  if (getToken()) {
    config.headers = header;
  }
  if (config.isPublic) {
    config.baseURL = Constants.PUBLICURL;
  }
  // Check if withCredentials should be set
  if (config.withCredentials) {
    config.withCredentials = true;
  }
  return axios(config);
};
export default DB;
